/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Error_Uploadcsv_Notcsv3Inputs */

const en_coinvestments_error_uploadcsv_notcsv3 = /** @type {(inputs: Coinvestments_Error_Uploadcsv_Notcsv3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selected file is not a CSV`)
};

/**
* | output |
* | --- |
* | "Selected file is not a CSV" |
*
* @param {Coinvestments_Error_Uploadcsv_Notcsv3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_error_uploadcsv_notcsv3 = /** @type {((inputs?: Coinvestments_Error_Uploadcsv_Notcsv3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Error_Uploadcsv_Notcsv3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_error_uploadcsv_notcsv3(inputs)
});
export { coinvestments_error_uploadcsv_notcsv3 as "coInvestments_error_uploadCsv_notCsv" }